import { Info } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import Paragraph from '../Typography/Paragraph';

interface InfoMessageProps {
  message: string;
  style?: string;
}

const InfoMessage: React.FC<InfoMessageProps> = ({ message, style }) => {
  if (!message) return <></>;
  const styles = `flex items-center gap-4 border-2 border-yellow rounded-theme px-4 py-2 bg-white`;
  const mergedStyles = twMerge(styles, style);
  return (
    <div
      aria-label="Message with important information"
      aria-live="polite"
      data-testid="info-message"
      role="dialog"
      className={mergedStyles}
    >
      <Info
        aria-hidden="true"
        className="self-start mt-2 shrink-0"
        size={16}
        strokeWidth={1.75}
      />
      <Paragraph html text={message} />
    </div>
  );
};

export default InfoMessage;
